import { useMemo } from 'react';
import { useRealplayStore } from 'features/realplays/RealPlays.store';

const RealPlayRecordDataHelper = () => {
  //values
  const { realPlayRecording, isLoadingVideoTemp } = useRealplayStore();
  const assignment_uuid = useMemo(
    () => realPlayRecording?.assignment_uuid,
    [realPlayRecording?.assignment_uuid]
  );
  const assigned_by_user = useMemo(
    () => realPlayRecording?.assigned_by_user,
    [realPlayRecording?.assigned_by_user]
  );
  const roleplay = useMemo(() => realPlayRecording?.roleplay, [realPlayRecording?.roleplay]);
  const scenarios = useMemo(() => realPlayRecording?.scenarios, [realPlayRecording?.scenarios]);
  const ratingCriteria = useMemo(
    () => realPlayRecording?.rating_criteria,
    [realPlayRecording?.rating_criteria]
  );
  const client = useMemo(() => realPlayRecording?.ai_persona, [realPlayRecording?.ai_persona]);
  const attitude = useMemo(() => realPlayRecording?.attitude, [realPlayRecording?.attitude]);
  const voice_id = useMemo(() => realPlayRecording?.voice_id, [realPlayRecording?.voice_id]);
  const customer_context = useMemo(
    () => realPlayRecording?.customer_context,
    [realPlayRecording?.customer_context]
  );
  const selectedScenario = useMemo(
    () => realPlayRecording?.scenarioSelected,
    [realPlayRecording?.scenarioSelected]
  );
  const sessionInfoTemp = useMemo(
    () => realPlayRecording?.sessionInfoTemp,
    [realPlayRecording?.sessionInfoTemp]
  );
  const endDate = useMemo(() => realPlayRecording?.end_date, [realPlayRecording?.end_date]);
  const session_uuid = useMemo(() => sessionInfoTemp?.session_id, [sessionInfoTemp]);
  const title = useMemo(() => realPlayRecording?.roleplay?.name, [realPlayRecording?.roleplay]);
  const isRecording = useMemo(() => selectedScenario?.isRecording, [selectedScenario?.isRecording]);
  const scenario_uuid = useMemo(() => selectedScenario?.uuid, [selectedScenario?.uuid]);
  const videoURL = useMemo(() => selectedScenario?.response?.video, [selectedScenario]);
  const status = useMemo(() => sessionInfoTemp?.status, [sessionInfoTemp]);
  const tempVideoUrl = useMemo(
    () => selectedScenario?.tempVideoUrl,
    [selectedScenario?.tempVideoUrl]
  );

  const persona_name = useMemo(() => client?.name, [client]);
  const persona_image = useMemo(() => client?.profile_pic, [client]);

  //functions
  const {
    setRealPlayRecording,
    setScenarioWithSelector,
    setIsRecordingScenario,
    setTempVideoUrl,
    setSessionInfoTemp,
    updateSessionStatus,
    setIsLoadingVideoTemp,
    reset,
  } = useRealplayStore();

  return {
    isLoadingVideoTemp,
    assignment_uuid,
    assigned_by_user,
    roleplay,
    scenarios,
    ratingCriteria,
    client,
    attitude,
    voice_id,
    customer_context,
    selectedScenario,
    sessionInfoTemp,
    endDate,
    session_uuid,
    title,
    isRecording,
    scenario_uuid,
    videoURL,
    status,
    tempVideoUrl,
    persona_name,
    persona_image,
    setRealPlayRecording,
    setScenarioWithSelector,
    setIsRecordingScenario,
    setTempVideoUrl,
    setSessionInfoTemp,
    updateSessionStatus,
    setIsLoadingVideoTemp,
    reset,
  };
};

export default RealPlayRecordDataHelper;
